import moment from 'moment';
import consts from '../../../main/consts';

export default function ValidateDevolutionDate(timelines, days) {
    try {
        const daysLimit = days !== undefined ? days : consts.DAYS_TO_DEVOLUTION;
        const timeline = timelines.find(status => status.nome === 'FINALIZADO' || status.nome === 'ENTREGUE');
        if (!timeline) return false;
        const limit = moment(timeline.data).add(daysLimit, 'days');
        return moment().isAfter(limit);
    } catch (e) {
        return false;
    }
}
